const quickContactData = [
  {
    id: 1,
    heading: 'АДРЕСА',
    fisrtData: 'Ресторан "Apetitto"',
    secoundData: 'Київ, Богдана Хмельницького 54',
  },
  {
    id: 2,
    heading: 'БРОНЮВАННЯ',
    fisrtData: '+380 63 073 1845',
    secoundData: '+380 96 075 2710',
  },
  {
    id: 3,
    heading: 'ГОДИНИ РОБОТИ',
    fisrtData: 'Понеділок - пятниця: 7:30 - 23:00.',
    secoundData: 'Субота - неділя: 15:30 - 21:00',
  },
];

export default quickContactData;
